import { sylvanus } from '~/services/serviceInstances';
import { SearchApi } from '~/types/SearchApi';

import {
  DynamoDbPageTargetEntityResponseItem,
  TargetEntityResponseItem,
} from '../../types/sylvanus/noRbac';

const MAX_ITERATION_COUNT = 3;

export const getPromptModelTargetEntities = async ({
  searchApi = 'pilot',
}: { searchApi?: SearchApi } = {}): Promise<TargetEntityResponseItem[]> => {
  let postDataCursor: string | null = null;

  const responses: TargetEntityResponseItem[] = [];
  let shouldEnd = false;
  let iterationCount = 0;
  const useEvisearch = searchApi === 'evisearch';

  while (!shouldEnd && iterationCount < MAX_ITERATION_COUNT) {
    const base = `/model/target-entities?use_evisearch=${useEvisearch}`;
    const endpoint = postDataCursor ? `${base}&cursor=${postDataCursor}` : base;
    const response: DynamoDbPageTargetEntityResponseItem =
      await sylvanus.get(endpoint);

    const { items, cursor } = response;
    postDataCursor = cursor ?? null;

    shouldEnd = cursor == null;

    responses.push(...items);
    iterationCount += 1;
  }

  return responses;
};
